import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#2A2A2A] py-8 px-6 bg-[#050505]" data-testid="app-footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-4">
          <span className="font-outfit text-lg font-bold text-[#D4AF37]">Prestigious Wireless</span>
          <div className="flex items-center gap-6 text-sm font-manrope">
            <Link to="/terms" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors" data-testid="footer-terms">Terms</Link>
            <Link to="/privacy" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors" data-testid="footer-privacy">Privacy</Link>
            <Link to="/faq" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors" data-testid="footer-faq">FAQ</Link>
            <Link to="/contact" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors" data-testid="footer-contact">Contact</Link>
          </div>
        </div>
        <div className="text-center space-y-1">
          <p className="text-[#A0A0A0] text-sm font-manrope">&copy; 2026 Prestigious Wireless. All rights reserved.</p>
          <p className="text-[#A0A0A0]/60 text-xs font-manrope">
            Powered by{" "}
            <a href="https://prestigiouscompanies.org" target="_blank" rel="noopener noreferrer" className="text-[#A0A0A0]/80 hover:text-[#D4AF37] transition-colors" data-testid="footer-powered-link">
              Prestigious Companies
            </a>
          </p>
          <p className="text-[#A0A0A0]/40 text-xs font-manrope">Prestigious Wireless v1.18</p>
        </div>
      </div>
    </footer>
  );
}
